import { render, staticRenderFns } from "./clifor.vue?vue&type=template&id=71428754"
import script from "./clifor.vue?vue&type=script&lang=js"
export * from "./clifor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports